import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { Step, StepStatus } from 'src/app/core/steps.service';
import { UtilsService } from 'src/app/core/utils.service';
import { STEPS_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';
import { StepsQineticReloadDialogComponent } from '../steps-qinetic-reload-dialog/steps-qinetic-reload-dialog.component';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { StepsRequestsDialogComponent } from '../steps-requests-dialog/steps-requests-dialog.component';

@Component({
  selector: 'app-steps-data-table',
  templateUrl: './steps-data-table.component.html',
  styleUrls: ['./steps-data-table.component.scss'],
})
export class StepsDataTableComponent {
  @Input() steps: Step[] = [];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();

  displayed_columns: string[] = STEPS_TABLE_COLUMNS;
  completed_step_status: StepStatus = StepStatus.completed;

  constructor(
    private utils_service: UtilsService,
    private dialog_service: DialogService,
    private error_service: ErrorService,
  ) {}

  onQineticReloadClick(step: Step): void {
    this.dialog_service
      .openDialog(StepsQineticReloadDialogComponent, { step })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onRequestsClick(step: Step): void {
    this.dialog_service.openDialog(StepsRequestsDialogComponent, {
      buyer_id: step.buyer_id,
      step_id: step.step_id,
    });
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  getCurrencyLabel(step: Step): string {
    return this.utils_service.getCurrencyLabelFromStep(step);
  }

  getStepStatusClass(status: StepStatus): string {
    return this.utils_service.getStepStatusClass(status);
  }

  getPaymentDate(step: Step): number | null {
    if (step.status !== StepStatus.completed) {
      return null;
    }
    if (step.completed_by_bank_transfer_at) {
      return step.completed_by_bank_transfer_at;
    }
    if (step.is_manually_paid && step.manual_payment_collected_at) {
      return step.manual_payment_collected_at;
    }
    if (step.completed_at) {
      return step.completed_at;
    }
    return null;
  }

  getPaymentSource(step: Step): string | null {
    if (step.status !== StepStatus.completed) {
      return null;
    }
    if (step.completed_by_bank_transfer_at) {
      return 'STEPS.PAYMENT_SOURCE_BNPLFLPARTI';
    }
    if (step.is_manually_paid && step.manual_payment_collected_at) {
      return 'STEPS.PAYMENT_SOURCE_MANUAL';
    }
    if (step.completed_at && step.is_manually_paid === false) {
      return 'STEPS.PAYMENT_SOURCE_STEP_CHARGER';
    }
    return null;
  }
}
